// extracted by mini-css-extract-plugin
module.exports = {"component":"released-menu_component__1csDh"};